<template>
    <div :class="[{'app-en':lang === 'en'}, 'app-canvas-wrap']">
        <Nav ref="navchild"></Nav>
        <Loader :speed="loadprogress" v-if="!hadLoaded" />
        <div ref="webgl" id="webgl"></div>
        <!-- logo -->
        <div class="logo">
            <a href="/"><img src="../assets/logo.png" /></a>
        </div>
        <!-- CN|EN -->
        <language @custom-event="handleChildEvent" />
        <!-- 菜单栏 -->
        <div class="app-toolbar">
            <div class="app-toolbar-circle">
                <div class="ring"></div>
                <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100%">
                    <g class="ring">
                        <g :class="[{'active':toobarActive == 'upper'}, 'toolbar-item']" @click="selectToobar('upper')">
                            <path
                              d="M 598.8792036093395 91.56563375186738 L 583.7391040605069 13.011337970850718 A 720 720 0 0 1 720.0000000000024 0 L 720.0000000000022 80 A 640 640  0 0 0 598.8792036093395 91.56563375186738 z"
                              fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="15" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1032">换辅机镶块</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="12px" x="8" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1032">Surface inlay block</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'down'}, 'toolbar-item']" @click="selectToobar('down')">
                            <path
                                d="M 482.13602837739217 125.84452286971282 L 452.40303192456616 51.57508822842692 A 720 720 0 0 1 583.7391040605069 13.011337970850718 L 598.8792036093395 91.56563375186738 A 640 640  0 0 0 482.13602837739217 125.84452286971282 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="27" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1031">换排序杆</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="12px" x="3" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1031">Stream division core</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'outer'}, 'toolbar-item']" @click="selectToobar('outer')">
                            <path
                                d="M 720 80 L 720 0 A 720 720 0 0 1 856.2608959394953 13.011337970851173 L 841.1207963906625 91.56563375186772 A 640 640  0 0 0 720 80 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="15" @mouseenter="greet" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1000">拆主机镶块</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="13px" x="15" @mouseenter="greet" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1000">Host inlay block</textPath>
                            </text>
                        </g>
                        <g :class="[{'active':toobarActive == 'principle'}, 'toolbar-item']" @click="selectToobar('principle')">
                            <path
                                d="M 841.1207963906625 91.56563375186772 L 856.2608959394953 13.011337970851173 A 720 720 0 0 1 987.5969680754358 51.57508822842772 L 957.8639716226096 125.8445228697135 A 640 640  0 0 0 841.1207963906625 91.56563375186772 z"
                                fill="transparent" stroke="transparent" stroke-width="0">
                            </path>
                            <text fill="rgba(255,255,255,0.7)" font-size="20px" x="42" v-if="lang == 'cn'">
                                <textPath xlink:href="#SvgjsPath1001">原 理</textPath>
                            </text>
                            <text fill="rgba(255,255,255,0.7)" font-size="18px" x="25" v-if="lang == 'en'">
                                <textPath xlink:href="#SvgjsPath1001">Principle</textPath>
                            </text>
                          </g>
                          <!-- 椭圆  A(rx, ry, xr, laf, sf, x, y)
                          rx: 椭圆X轴半径
                          ry: 椭圆Y轴半径
                          xr: 椭圆旋转角度
                          laf: 是否选择弧长较长的那一段。0: 短边（小于180度）; 1: 长边（大于等于180度）
                          sf: 是否顺时针绘制。0: 逆时针; 1: 顺时针
                          x: 终点X轴坐标
                          y: 终点Y轴坐标 -->
                    </g>
                    <defs>
                        <path id="SvgjsPath1000"
                            d="M 720 49 L 720 48 A 672 672 0 0 1 847.1768362101957 60.143915439461125 L 846.9875849658353 61.1258441367238 A 671 671  0 0 0 720 49 z">
                        </path>
                        <path id="SvgjsPath1001"
                            d="M 846.9875849658353 61.1258441367238 L 847.1768362101957 60.143915439461125 A 672 672 0 0 1 969.7571702037401 96.13674901319928 L 969.3855077480798 97.06511694621531 A 671 671  0 0 0 846.9875849658353 61.1258441367238 z">
                        </path>
                        <path id="SvgjsPath1031"
                            d="M 470.6144922519221 97.06511694621452 L 470.2428297962618 96.13674901319848 A 672 672 0 0 1 592.8231637898064 60.14391543946067 L 593.0124150341668 61.12584413672346 A 671 671  0 0 0 470.6144922519221 97.06511694621452 z">
                        </path>
                        <path id="SvgjsPath1032"
                            d="M 593.0124150341668 61.12584413672346 L 592.8231637898064 60.14391543946067 A 672 672 0 0 1 720.0000000000023 48 L 720.0000000000023 49 A 671 671  0 0 0 593.0124150341668 61.12584413672346 z">
                        </path>
                    </defs>
                </svg>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'upper'">
                    <div
                      v-for="(item,index) in upperObj"
                      :key="index"
                      :class="[{'active':upperActive === item.id}, 'app-submenu-item']"
                      @click="upperAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'down'">
                    <div
                      v-for="(item,index) in downObj"
                      :key="index"
                      :class="[{'active':downActive === item.id}, 'app-submenu-item']"
                      @click="downAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'outer'">
                    <div
                      v-for="(item,index) in outerObj"
                      :key="index"
                      :class="[{'active':outerActive === item.id}, 'app-submenu-item']"
                      @click="outerAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
            <div class="app-submenu-wrap" v-if="toobarActive === 'principle'">
                    <div
                      v-for="(item,index) in principleObj"
                      :key="index"
                      :class="[{'active':principleActive === item.id}, 'app-submenu-item']"
                      @click="principleAnimate(item)"
                    >
                        <template v-if="lang == 'cn'">
                            {{ item.text }}
                        </template>
                        <template v-if="lang == 'en'">
                            {{ item.en_text }}
                        </template>
                    </div>
            </div>
        </div>
        <!-- 配件列表 -->
        <div class="sub-nav">
          <div
            class="sub-item"
            v-for="(item,index) in accessoryObj"
            :key="index"
            @click="focusaccessory(item)"
            :class="{'accessoryactive':accessoryActive === item.id}"
          >
            <template v-if="lang == 'cn'">
                {{ item.text }}
            </template>
            <template v-if="lang == 'en'">
                {{ item.en_text }}
            </template>
          </div>
        </div>

        <!-- 注意事项文字 -->
        <transition>
          <div class="app-text" v-if="attentionStatus&&attentionText">
            <div class="title" @click="shownote()">
                <img src="../assets/images/text.png" />
                <span  v-show="lang == 'cn'">注意</span>
                <span  v-show="lang == 'en'">NOTE</span>
            </div>
            <div class="content" v-html="attentionText" v-show="is_hidenote"></div>
          </div>
        </transition>

        <!-- <div @click="test" class="test">测试</div> -->

    </div>
</template>

<script>
    import * as THREE from  'three';
    import TWEEN from '@tweenjs/tween.js';
    import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
    import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
    import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
    import { MeshoptDecoder } from 'three/examples/jsm/libs/meshopt_decoder.module.js'
    import Loader from './Loader.vue';
    import Nav from './nav.vue';
    import language from './language.vue';

    export default {
        components: {
            Loader,
            Nav,
            language,
        },
        data() {
            return {
                timer: null, // 定时器
                hadLoaded: false, // 是否已加载完毕
                loadprogress: 0, // 加载进度
                modelLoaded: false, // 模型是否加载

                Clock: null, // 用于跟踪时间
                camera: null, // 相机对象
                renderer: null, // 渲染器对象
                container: null, // DOM节点
                controls: null, // 轨道控制器
                containerW: 0, // DOM宽度
                containerH: 0, // DOM高度
                model: null, //模型
                toobarActive: null, // 工具栏状态

                attentionStatus: false, // 注意事项状态
                attentionText: null, // 注意事项文字
                is_hidenote:true,

                upperActive:null, //当前选项下标
                downActive:null, //当前选项下标
                outerActive:null, //当前选项下标
                principleActive:null, //当前选项下标
                modelanimationList:[], //动画列表
                selectobject: '', //当前选择的选项
                accessoryActive:null,
                settimeoutList:[],
                lang: 'cn', // 语言
                upperObj:[ //菜单1选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>1.拔掉四芯接插件。</p>',
                    en_warn: '<p>1.Pull out the four-pin connector.</p>',
                    animate_number: '7',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>2.松开镶块盖板紧固螺丝,利用顶出螺丝孔将盖板及镶块顶出。</p>',
                    en_warn: '<p>2.Loosen the screws, use the ejector screw hole to push out the insert with the cover.</p>',
                    animate_number: '8',
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>3.利用顶出螺丝孔将盖板及镶块顶出,按需求更换镶块或堵块,装上盖板，对角依次均匀拧紧紧固螺丝。</p>',
                    en_warn: '<p>3.Install the replacement insert with cover and tighten all fastening screws diagonally one by one.</p>',
                    animate_number: '9',
                  },
                  {
                    id: 3,
                    text: '第四步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>4.装回四芯接插件。</p>',
                    en_warn: '<p>4.Put back the four-pin connector.</p>',
                    animate_number: '10',
                  },
                ],
                downObj: [ //菜单2选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>1.松开排序杆盖板紧固螺丝。</p>',
                    en_warn: '<p>1.Loosen the fastening screws of the sorting rod cover plate.</p>',
                    animate_number: '3',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>2.利用顶出螺丝孔将排序杆盖板顶出。</p>',
                    en_warn: '<p>2.Use the screw hole to push out the sorting rod cover plate.</p>',
                    animate_number: '4',
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>3.按需求更换排序杆。</p>',
                    en_warn: '<p>3.Loosen the fastening screws of the sorting rod and use the forcing screw hole to push out the sorting rod cover plate and sorting rod.</p>',
                    animate_number: '5',
                  },
                  {
                    id: 3,
                    text: '第四步', //菜单显示
                    en_text: 'Step 4', //菜单显示(英文)
                    warn: '<p>4.装回排序杆盖板,对角依次均匀拧紧紧固螺丝。</p>',
                    en_warn: '<p>4.Replace the sorting rod as needed and tighten the fastening screws evenly diagonally.</p>',
                    animate_number: '6',
                  },
                ],
                outerObj: [ //菜单3选项
                  {
                    id: 0,
                    text: '第一步', //菜单显示
                    en_text: 'Step 1', //菜单显示(英文)
                    warn: '<p>1.松开侧板紧固螺丝,利用顶出螺丝孔将侧板顶出，另一侧侧板同理。</p>',
                    en_warn: '<p>1.Loosen the screws, use the ejector screw hole to push out the side plate, same steps for the other side.</p>',
                    animate_number: '0',
                  },
                  {
                    id: 1,
                    text: '第二步', //菜单显示
                    en_text: 'Step 2', //菜单显示(英文)
                    warn: '<p>2.将主机镶块往对面慢慢推出即可。</p>',
                    en_warn: '<p>2.Slowly push the insert to the opposite side.</p>',
                    animate_number: '1',
                  },
                  {
                    id: 2,
                    text: '第三步', //菜单显示
                    en_text: 'Step 3', //菜单显示(英文)
                    warn: '<p>3.对角依次均匀拧紧紧固螺丝，对面侧板同理。</p>',
                    en_warn: '<p>3.Tighten all fastening screws diagonally one by one,same steps for the other side.</p>',
                    animate_number: '2',
                  },
                ],
                principleObj: [
                  {
                    id: 0,
                    text: 'ABC', //菜单显示
                    en_text: 'ABC', //菜单显示(英文)
                    warn: '<p>1.ABA</p>',
                    en_warn: '<p>ABA</p>',
                  },
                  {
                    id: 1,
                    text: 'ABB', //菜单显示
                    en_text: 'ABB', //菜单显示(英文)
                    warn: '<p>1.ABA</p>',
                    en_warn: '<p>ABA</p>',
                  },
                  {
                    id: 2,
                    text: 'ABA', //菜单显示
                    en_text: 'ABA', //菜单显示(英文)
                    warn: '<p>1.ABA</p>',
                    en_warn: '<p>ABA</p>',
                  },
                ],
                accessoryObj: [
                  {
                    id: 0,
                    text: '排序杆ABA', //菜单显示
                    en_text: 'Stream division core ABA', //菜单显示(英文)
                  },
                  {
                    id: 1,
                    text: '排序杆ABC', //菜单显示
                    en_text: 'Stream division core ABC', //菜单显示(英文)
                  },
                  {
                    id: 2,
                    text: '排序杆ABB', //菜单显示
                    en_text: 'Stream division core ABB', //菜单显示(英文)
                  },
                  {
                    id: 3,
                    text: '排序杆BBA', //菜单显示
                    en_text: 'Stream division core BBA', //菜单显示(英文)
                  },
                  {
                    id: 4,
                    text: '排序杆BBB', //菜单显示
                    en_text: 'Stream division core BBB', //菜单显示(英文)
                  },
                ]
            }
        },
        methods: {
          greet () {},
          /**
           * @description 打开链接
           * @param {*} link
           */
          openLink: function(link) {
            if (this.lang == 'cn') {
              window.open('https://www.jc-times.com/', '_blank');
            } else {
              window.open('https://en.jc-times.com/', '_blank');
            }
          },
          /**
           * @description 相机动画
           */
          tweenCamera: function(oldP, oldT, newP, newT, callBack) {
            var _this = this
            var tween = new TWEEN.Tween({
              x1: oldP.x, // 相机x
              y1: oldP.y, // 相机y
              z1: oldP.z, // 相机z
              x2: oldT.x, // 控制点的中心点x
              y2: oldT.y, // 控制点的中心点y
              z2: oldT.z  // 控制点的中心点z
            });
            tween.to({
              x1: newP.x,
              y1: newP.y,
              z1: newP.z,
              x2: newT.x,
              y2: newT.y,
              z2: newT.z
            }, 1000);
            tween.onUpdate(function (object) {
              _this.camera.position.x = object.x1;
              _this.camera.position.y = object.y1;
              _this.camera.position.z = object.z1;
              _this.controls.target.x = object.x2;
              _this.controls.target.y = object.y2;
              _this.controls.target.z = object.z2;
              _this.controls.update();
            })
            tween.onComplete(function () {
              _this.controls.enabled = true;
              callBack && callBack()
            })
            tween.easing(TWEEN.Easing.Cubic.InOut);
            tween.start();
          },

          /**
           * @description 初始化Canvas
           */
          initCanvas: function() {
              let _this = this;

              _this.clock = new THREE.Clock();

              // 创建渲染器
              _this.initRenderer();

              // 创建场景
              _this.initScene();

              // 创建相机
              _this.initCamera();

              // 创建相机控制器
              _this.initControls();

              // 创建环境贴图
              _this.initPmremGenerator();

              // 加载模型
              _this.loadModel();

          },

          /**
           * @description 初始化渲染器
           */
          initRenderer: function() {
              let _this = this;
              _this.container = this.$refs.webgl;
              _this.containerW = this.$refs.webgl.getBoundingClientRect().width;
              _this.containerH = this.$refs.webgl.getBoundingClientRect().height;
              _this.renderer = new THREE.WebGLRenderer({
                  antialias: true,
                  alpha: true
              });
              _this.renderer.setSize(this.containerW,this.containerH);
              _this.renderer.localClippingEnabled = true;
              _this.renderer.sortObjects = false; //(物体的渲染顺序将会由他们添加到场景中的顺序所决定) 关闭自定义顺序，也就是按照默认排序。 决定是材质先后起作用还是添加到场景的先后起作用
              _this.renderer.clippingPlanes = Object.freeze([])
              _this.renderer.setClearAlpha(0);
              _this.renderer.setPixelRatio(window.devicePixelRatio);
              _this.renderer.outputEncoding = THREE.sRGBEncoding;
              _this.container.appendChild(_this.renderer.domElement);
          },
          /**
           * @description 初始化场景
           */
          initScene: function() {
              let _this = this;
              _this.scene = new THREE.Scene();
          },
          /**
           * @description 初始化相机
           */
          initCamera: function() {
            let _this = this;
            _this.camera = new THREE.PerspectiveCamera(45, this.containerW / this.containerH, 0.1, 10000);
            _this.camera.position.set(0, 0, 6);
            _this.camera.lookAt(_this.scene.position);
          },
          /**
           * @description 初始化相机控制器
           */
          initControls: function() {
              let _this = this;
              _this.controls = new OrbitControls(_this.camera, _this.renderer.domElement);
              _this.controls.enablePan = false;
              _this.controls.enableDamping = true;
              _this.controls.dampingFactor = 0.1;
              _this.controls.maxPolarAngle = Math.PI;
              _this.controls.minPolarAngle = 0;
              _this.controls.enablePan = false;
              _this.controls.enableZoom = true;
          },
          /**
           * @description 初始化环境贴图
           */
          initPmremGenerator: function() {
            let _this = this;
            let pmremGenerator = new THREE.PMREMGenerator(_this.renderer);
            let loaderRGBE = new RGBELoader();
            pmremGenerator.compileEquirectangularShader()
            loaderRGBE.load('../../static/hdr/photo_studio_01_1k.hdr', texture => {
              const envMap = pmremGenerator.fromEquirectangular(texture).texture;
              _this.scene.environment = envMap;
              texture.dispose();
              pmremGenerator.dispose();
            })
          },

          /**
           * @description 加载模型文件
           */
          loadModel: function() {
              let _this = this;
              _this.textrueLoader = new THREE.TextureLoader();
              let loader = new GLTFLoader();

              loader.setMeshoptDecoder(MeshoptDecoder);
              loader.load("../../static/model/zhxkfpq/zhxkfpq-me2.glb", function(gltf) {
                console.log(gltf,'gltf');
                _this.model = gltf.scene;
                _this.modelanimationList = gltf.animations
                // _this.model.scale.set(0.1, 0.1, 0.1);
                _this.modelLoaded = true;
                // _this.model.position.set(0, 100, 0);
                _this.scene.add(_this.model);

                // 材质共享问题
                _this.model.traverse(function (object) {
                  if (object.isMesh) {
                    object.material = object.material.clone();
                  }
                })
                _this.initmodel()
                _this.optimization_model_meaterial_performance()
                _this.animate();
              });
          },

          /**
           * @description 循环渲染Canvas
           */
          animate: function() {
            let _this = this;

            _this.rafId = requestAnimationFrame(_this.animate);
            _this.controls.update();
            TWEEN.update();
            if(_this.mixer){
              let mixerUpdateDelta = _this.clock.getDelta();
              _this.mixer.update( mixerUpdateDelta );
            }
            // _this.composer.render(); // 使用处理对象渲染场景
            _this.renderer.render(_this.scene, _this.camera);
            // _this.labelRenderer.render(_this.scene, _this.camera); //渲染html标签
          },
          /**
           * @description 改变窗口大小，重新渲染Canvas
           */
          onResize: function() {
              let _this = this;
              _this.$nextTick(()=>{
                if(_this.$refs.webgl.getBoundingClientRect()){
                  _this.containerW = _this.$refs.webgl.getBoundingClientRect().width
                  _this.containerH = _this.$refs.webgl.getBoundingClientRect().height
                  _this.camera.aspect = _this.containerW / _this.containerH;
                  _this.camera.updateProjectionMatrix();
                  _this.renderer.setSize(_this.containerW, _this.containerH);
                }
              })
          },
          /**
           * @description 选择语言
           */
          selectLang: function(e) {
              let _this = this;
              _this.lang = e;
              _this.toobarActive = '';
              _this.dismantleActive = '';
              _this.assembleActive = '';
          },
          /**
           * @description 选择菜单
           * @param {String} e 菜单
           */
          selectToobar: function(e) {
            let _this = this
            if ( this.toobarActive == e ) {
              this.toobarActive = '';
              this.resetSetTimeOut()
              if(_this.clipAction){ //如果有动画则先停止播放
                _this.clipAction.stop()
                this.attentionStatus = false
              }
              _this.initmodel()
            }else{
              this.toobarActive = e;
              this.attentionStatus = true
            }
            if(this.accessoryActive != null){
              this.initmodel()
              this.accessoryActive = null
              var oldP = { //旧的相机位置
                x: this.camera.position.x,
                y: this.camera.position.y,
                z: this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: this.controls.target.x,
                y: this.controls.target.y,
                z: this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 10,
              }
              this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          optimization_model_meaterial_performance(){
            let _this = this;
            _this.model.traverse(function (object) {
              if (object.isMesh && object.material.isMeshPhysicalMaterial) {
                console.log(object,'isMeshPhysicalMaterial');
                let now_material = object.material
                // 创建一个新的 MeshStandardMaterial，可以根据需要调整属性
                let materialStandard = new THREE.MeshStandardMaterial({
                  color: now_material.color,
                  roughness: now_material.roughness, // 粗糙度
                  metalness: now_material.metalness, // 金属度
                  normalMap: now_material.normalMap, // 法线贴图
                  roughnessMap: now_material.roughnessMap, // 粗糙贴图
                  normalScale: now_material.normalScale, // 法线贴图强度
                  // 其他属性根据需要进行调整或者添加
                });
                // 将模型的材质替换为新的 MeshStandardMaterial
                object.material = materialStandard;
              }
            })
          },
          /**
           * @description 菜单选项1
           * @param {number} e 菜单选项对象
           */
          upperAnimate: function(item) { //hx
            let _this = this;
            this.upperActive = item.id
            this.downActive = null
            this.outerActive = null
            this.principleActive = null
            this.accessoryActive = null

            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            var oldP = { //旧的相机位置
              x: this.camera.position.x,
              y: this.camera.position.y,
              z: this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: this.controls.target.x,
              y: this.controls.target.y,
              z: this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            this.resetSetTimeOut()
            _this.initmodel()
            switch (item.id) {
              case 0:
                var newP = { //新的相机位置
                  x: 0,
                  y: 0,
                  z: 6,
                }
                break;
              case 1:
                var newP = { //新的相机位置
                  x: -3.93,
                  y: 2,
                  z: 6.5,
                }
                _this.ShowHideComponents(["DCLS1","DK","XXK"],true)
                break;
              case 2:
                var newP = { //新的相机位置
                  x: -2.64,
                  y: -0.97,
                  z: 3.79,
                }
                _this.ShowHideComponents(["DCLS1","DK","XXK"],true)
                break;
              case 3:
                var newP = { //新的相机位置
                  x: 0,
                  y: 0,
                  z: 6,
                }
                break;
              default:
                break;
            }
            this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 菜单选项2
           * @param {Number} e 菜单选项对象
           */
          downAnimate: function(item) { //HG
            let _this = this;
            this.downActive = item.id
            this.upperActive = null
            this.outerActive = null
            this.principleActive = null

            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            var oldP = { //旧的相机位置
              x: this.camera.position.x,
              y: this.camera.position.y,
              z: this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: this.controls.target.x,
              y: this.controls.target.y,
              z: this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            this.resetSetTimeOut()
            _this.initmodel()
            switch (item.id) {
              case 0:
                var newP = { //新的相机位置
                  x: -4.07,
                  y: 1.53,
                  z: -5.18,
                }
                _this.ShowHideComponents(["DCLS2"],true)
                break;
              case 1:
                var newP = { //新的相机位置
                  x: -4.68,
                  y: 3.09,
                  z: 4.97,
                }
                _this.ShowHideComponents(["DCLS3","ABBG"],true)
                break;
              case 2:
                var newP = { //新的相机位置
                  x: -4.68,
                  y: 2.09,
                  z: 4.97,
                }
                _this.ShowHideComponents(["ABBG"],true)
                break;
              case 3:
                var newP = { //新的相机位置
                  x: -4.07,
                  y: 1.53,
                  z: -5.18,
                }
                _this.ShowHideComponents(["ABBG"],true)
                break;
              default:
                break;
            }
            this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 菜单选项3
           * @param {Number} e 菜单选项对象
           */
          outerAnimate: function(item){ //CX
            let _this = this;
            this.outerActive = item.id
            this.principleActive = null
            this.downActive = null
            this.upperActive = null

            this.selectobject = item
            if (_this.lang == 'cn') {
              if(item.warn){
                _this.attentionText = item.warn;
              }else{
                _this.attentionText = null
              }
            } else {
              if(item.en_warn){
                _this.attentionText = item.en_warn;
              }else{
                _this.attentionText = null
              }
            }

            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            //包含关键帧动画的模型作为参数创建一个播放器
            _this.mixer = new THREE.AnimationMixer(_this.model);  //被此动作控制的 动画混合器
            //  获取gltf.animations[0]的第一个clip动画对象
            _this.clipAction = _this.mixer.clipAction(_this.modelanimationList[item.animate_number]); //创建动画clipAction对象(动画剪辑 保存了此动作当中的动画数据)
            _this.clipAction.play(); //播放动画
            _this.clipAction.loop = THREE.LoopOnce; //不循环播放
            _this.clipAction.clampWhenFinished = true // 物体状态停留在动画结束的时候
            this.resetSetTimeOut()
            _this.initmodel()

            switch (item.id) {
              case 0:
                _this.ShowHideComponents(["DCLS4","DCLS5"],true)
                var oldP = { //旧的相机位置
                  x: this.camera.position.x,
                  y: this.camera.position.y,
                  z: this.camera.position.z,
                }
                var oldT = { //旧的聚焦位置
                  x: this.controls.target.x,
                  y: this.controls.target.y,
                  z: this.controls.target.z,
                }
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: 6,
                  y: 1.43,
                  z: -4.2,
                }
                this.tweenCamera(oldP, oldT, newP, newT);

                _this.settimeoutList.push(
                  setTimeout(() => {
                    var oldP = { //旧的相机位置
                      x: this.camera.position.x,
                      y: this.camera.position.y,
                      z: this.camera.position.z,
                    }
                    var oldT = { //旧的聚焦位置
                      x: this.controls.target.x,
                      y: this.controls.target.y,
                      z: this.controls.target.z,
                    }
                    var newT = { //新的聚焦位置
                      x: 0,
                      y: 0,
                      z: 0,
                    }
                    var newP = { //新的相机位置
                      x: -5.6,
                      y: 1,
                      z: -4.86,
                    }
                    this.tweenCamera(oldP, oldT, newP, newT);
                  }, 3000)
                )
                break;
              case 1:
                var oldP = { //旧的相机位置
                  x: this.camera.position.x,
                  y: this.camera.position.y,
                  z: this.camera.position.z,
                }
                var oldT = { //旧的聚焦位置
                  x: this.controls.target.x,
                  y: this.controls.target.y,
                  z: this.controls.target.z,
                }
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: 4.38,
                  y: 2.54,
                  z: -4.97,
                }
                this.tweenCamera(oldP, oldT, newP, newT);
                break;
              case 2:
                var oldP = { //旧的相机位置
                  x: this.camera.position.x,
                  y: this.camera.position.y,
                  z: this.camera.position.z,
                }
                var oldT = { //旧的聚焦位置
                  x: this.controls.target.x,
                  y: this.controls.target.y,
                  z: this.controls.target.z,
                }
                var newT = { //新的聚焦位置
                  x: 0,
                  y: 0,
                  z: 0,
                }
                var newP = { //新的相机位置
                  x: -5.6,
                  y: 1,
                  z: -4.86,
                }
                this.tweenCamera(oldP, oldT, newP, newT);

                _this.settimeoutList.push(
                  setTimeout(() => {
                    var oldP = { //旧的相机位置
                      x: this.camera.position.x,
                      y: this.camera.position.y,
                      z: this.camera.position.z,
                    }
                    var oldT = { //旧的聚焦位置
                      x: this.controls.target.x,
                      y: this.controls.target.y,
                      z: this.controls.target.z,
                    }
                    var newT = { //新的聚焦位置
                      x: 0,
                      y: 0,
                      z: 0,
                    }
                    var newP = { //新的相机位置
                      x: 6,
                      y: 1.43,
                      z: -4.2,
                    }
                    this.tweenCamera(oldP, oldT, newP, newT);
                  }, 2500)
                )
                break;
              default:
                break;
            }
          },
          principleAnimate: function(item){
            let _this = this
            this.principleActive = item.id
            this.downActive = null
            this.upperActive = null
            this.outerActive = null

            this.attentionStatus = false
            this.selectobject = item
            this.resetSetTimeOut()
            _this.initmodel()
            _this.initlocalPlane()
            if(_this.clipAction){ //如果有动画则先停止播放
              _this.clipAction.stop()
            }
            if(_this.tweenplane){
              _this.tweenplane.stop()
            }
            if(_this.tweenplane2){
              _this.tweenplane2.stop()
            }
            if(_this.tweenplane3){
              _this.tweenplane3.stop()
            }
            _this.transparentComponents(["BP1","BP2"],0.1)
            _this.transparentComponents(["CB1","CB2","JXK","JDK","111","222","ZXXK"],0.3)
            switch (item.id) {
              case 0: //ABC
                _this.ShowHideComponents(["ZXNB","ZX","ABAG","ABBG2"],false)
                _this.ShowHideComponents(["BRG_B","BRG_R","BRG_G","ABC","ABCG"],true)
                _this.transparentComponents(["ABC"],0.3)

                _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRG_R).to({constant: 2.5}, 5000);
                _this.tweenplane.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRG_R").children[0].material.clippingPlanes = [_this.localPlane_BRG_R];
                })
                _this.tweenplane.start();

                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRG_B).to({constant: -0.278}, 1478);
                //----------------------------------------------------------------------------- time ↑ = （X2 / X总）* 时间
                _this.tweenplane2.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRG_B").children[0].material.clippingPlanes = [_this.localPlane_BRG_B];
                }).onComplete(function(){
                  _this.localPlane_BRG_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -0.47)
                  _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRG_B).to({constant: 2.5}, 3522);
                  _this.tweenplane2.onUpdate(function () { //第一阶段
                    _this.model.getObjectByName("BRG_B").children[0].material.clippingPlanes = [_this.localPlane_BRG_B];
                  })
                  _this.tweenplane2.start();
                })
                _this.tweenplane2.start();

                _this.tweenplane3 = new TWEEN.Tween(_this.localPlane_BRG_G).to({constant: -0.278}, 1478);
                _this.tweenplane3.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRG_G").children[0].material.clippingPlanes = [_this.localPlane_BRG_G];
                }).onComplete(function(){
                  _this.localPlane_BRG_G = new THREE.Plane(new THREE.Vector3(0, 1, 0), -0.47)
                  _this.tweenplane3 = new TWEEN.Tween(_this.localPlane_BRG_G).to({constant: 2.5}, 3522);
                  _this.tweenplane3.onUpdate(function () { //第一阶段
                    _this.model.getObjectByName("BRG_G").children[0].material.clippingPlanes = [_this.localPlane_BRG_G];
                  })
                  _this.tweenplane3.start();
                })
                _this.tweenplane3.start();
                newP = { //新的相机位置
                  x: -5.9,
                  y: 0.75,
                  z: -2.5,
                }

                break;
              case 1: //ABB
                _this.ShowHideComponents(["BRR_B","BRR_R","ABBG2"],true)
                _this.ShowHideComponents(["ZXNB","ABAG"],false)
                _this.transparentComponents(["ZX"],0.3)

                _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRR_R).to({constant: 2.5}, 5000);
                _this.tweenplane.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRR_R").children[0].material.clippingPlanes = [_this.localPlane_BRR_R];
                })
                _this.tweenplane.start();

                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRR_B).to({constant: -0.278}, 1192);
                _this.tweenplane2.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRR_B").children[0].material.clippingPlanes = [_this.localPlane_BRR_B];
                }).onComplete(function(){
                  _this.localPlane_BRR_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -0.47)
                  _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRR_B).to({constant: 2.5}, 3808);
                  _this.tweenplane2.onUpdate(function () { //第一阶段
                    _this.model.getObjectByName("BRR_B").children[0].material.clippingPlanes = [_this.localPlane_BRR_B];
                  })
                  _this.tweenplane2.start();
                })
                _this.tweenplane2.start();

                newP = { //新的相机位置
                  x: -5.93,
                  y: 0.75,
                  z: -1,
                }

                break;
              case 2: //ABA
                _this.ShowHideComponents(["BRB_B","BRB_R"],true)
                _this.ShowHideComponents(["ZXNB"],false)
                _this.transparentComponents(["ZX"],0.3)

                _this.tweenplane = new TWEEN.Tween(_this.localPlane_BRB_R).to({constant: 2.5}, 5000);
                _this.tweenplane.onUpdate(function () { //第一阶段
                  _this.model.getObjectByName("BRB_R").children[0].material.clippingPlanes = [_this.localPlane_BRB_R];
                })
                _this.tweenplane.start();

                _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRB_B).to({constant: -0.278}, 1192);
                _this.tweenplane2.onUpdate(function () { //第一阶段1
                  _this.model.getObjectByName("BRB_B").children[0].material.clippingPlanes = [_this.localPlane_BRB_B];
                }).onComplete(function(){
                  _this.localPlane_BRB_B = new THREE.Plane(new THREE.Vector3(0, 1, 0), -0.47)
                  _this.tweenplane2 = new TWEEN.Tween(_this.localPlane_BRB_B).to({constant: 2.5}, 3808);
                  _this.tweenplane2.onUpdate(function () { //第一阶段
                    _this.model.getObjectByName("BRB_B").children[0].material.clippingPlanes = [_this.localPlane_BRB_B];
                  })
                  _this.tweenplane2.start();
                })
                _this.tweenplane2.start();
                newP = { //新的相机位置
                  x: -5.93,
                  y: 0.75,
                  z: 1,
                }
                break;
              default:
                break;
            }
            var oldP = { //旧的相机位置
              x: this.camera.position.x,
              y: this.camera.position.y,
              z: this.camera.position.z,
            }
            var oldT = { //旧的聚焦位置
              x: this.controls.target.x,
              y: this.controls.target.y,
              z: this.controls.target.z,
            }
            var newT = { //新的聚焦位置
              x: 0,
              y: 0,
              z: 0,
            }
            var newP
            this.tweenCamera(oldP, oldT, newP, newT);
          },
          /**
           * @description 配件菜单选项按钮
           */
          focusaccessory(item){
            let _this = this
            _this.toobarActive = null
            // _this.initmodel()
            this.resetSetTimeOut()
            _this.hideallcomponents()
            this.img_annotate_status = false
            this.attentionStatus = false
            if(this.clipAction){ //如果有动画则先停止播放
              this.clipAction.stop()
            }
            if(_this.accessoryActive == item.id){
              _this.initmodel()
              _this.accessoryActive = null
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              var newT = { //新的聚焦位置
                x: 0,
                y: 0,
                z: 0,
              }
              var newP = { //新的相机位置
                x: 0,
                y: 0,
                z: 10,
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }else{
              _this.accessoryActive = item.id
              var oldP = { //旧的相机位置
                x: _this.camera.position.x,
                y: _this.camera.position.y,
                z: _this.camera.position.z,
              }
              var oldT = { //旧的聚焦位置
                x: _this.controls.target.x,
                y: _this.controls.target.y,
                z: _this.controls.target.z,
              }
              switch (item.id) {
                case 0: //排序杆3 ABAG2
                  var newT = { //新的聚焦位置
                    x: 0.9,
                    y: 0.54,
                    z: 1.9,
                  }
                  var newP = { //新的相机位置
                    x: -1.7,
                    y: 1.45,
                    z: 3.85,
                  }
                  _this.testShowHideComponents("ABAG2")
                  break;
                case 1: //排序杆3 ABCG2
                  var newT = { //新的聚焦位置
                    x: -0.76,
                    y: 0.54,
                    z: 1.9,
                  }
                  var newP = { //新的相机位置
                    x: -3.36,
                    y: 1.45,
                    z: 3.85,
                  }
                  _this.testShowHideComponents("ABCG2")
                  break;
                case 2: //排序杆1 ABB
                  var newT = { //新的聚焦位置
                    x: -2.37,
                    y: 0.54,
                    z: 1.9,
                  }
                  var newP = { //新的相机位置
                    x: -4.97,
                    y: 1.45,
                    z: 3.85,
                  }
                  _this.testShowHideComponents("ABBG")
                  break;
                case 3: //排序杆2 BBA
                var newT = { //新的聚焦位置
                    x: -4.19,
                    y: 0.54,
                    z: 1.9,
                  }
                  var newP = { //新的相机位置
                    x: -6.79,
                    y: 1.45,
                    z: 3.85,
                  }
                  _this.testShowHideComponents("BBAG")
                  break;
                case 4: //排序杆3 BBB
                  var newT = { //新的聚焦位置
                    x: -5.99,
                    y: 0.54,
                    z: 1.9,
                  }
                  var newP = { //新的相机位置
                    x: -8.59,
                    y: 1.45,
                    z: 3.85,
                  }
                  _this.testShowHideComponents("BBBG")
                  break;
                default:
                  break;
              }
              _this.tweenCamera(oldP, oldT, newP, newT);
            }
          },
          /**
           * @description 重置所有计时器
           */
          resetSetTimeOut(){
            let _this = this;
            if(_this.settimeoutList.length != 0){
              for (let i = 0; i < _this.settimeoutList.length; i++) {
                clearInterval(_this.settimeoutList[i])
              }
              _this.settimeoutList.length = 0
            }
          },
          /**
           * @description 隐藏所有组件
           */
          hideallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              if(object.isMesh){
                object.visible = false
              }
            })
          },
          /**
           * @description 隐藏组件及其子组件
           */
          testShowHideComponents(name){
            let obj = this.model.getObjectByName(name)
            console.log(obj);
            obj.visible = true
            if(obj.children){
              for (let i = 0; i < obj.children[0].children.length; i++) {
                obj.children[0].children[i].visible = true
              }
            }
          },
          initlocalPlane(){
            let _this = this;

            _this.localPlane_BRG_B = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -1.2)  //X轴 -1.132
            _this.localPlane_BRG_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.7)  //顶部 1.652，底部 -2.491
            _this.localPlane_BRG_G = new THREE.Plane(new THREE.Vector3(1, 0, 0), -1.2) //X轴 1.145


            _this.localPlane_BRR_B = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -0.9)  //X轴 -0.8289
            _this.localPlane_BRR_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.4)  //顶部 1.652，底部 -2.491
            // _this.helper = new THREE.PlaneHelper( _this.localPlane_BRR_B, 1, 0xff0000 );
            // _this.scene.add( _this.helper );


            _this.localPlane_BRB_B = new THREE.Plane(new THREE.Vector3(-1, 0, 0), -0.9)  //X轴 -0.8289
            _this.localPlane_BRB_R = new THREE.Plane(new THREE.Vector3(0, 1, 0), -1.4) //顶部 1.4，底部 -2.45

            _this.model.getObjectByName("BRG_B").children[0].material.clippingPlanes = [_this.localPlane_BRG_B];
            _this.model.getObjectByName("BRG_R").children[0].material.clippingPlanes = [_this.localPlane_BRG_R];
            _this.model.getObjectByName("BRG_G").children[0].material.clippingPlanes = [_this.localPlane_BRG_G];

            _this.model.getObjectByName("BRR_B").children[0].material.clippingPlanes = [_this.localPlane_BRR_B];
            _this.model.getObjectByName("BRR_R").children[0].material.clippingPlanes = [_this.localPlane_BRR_R];

            _this.model.getObjectByName("BRB_B").children[0].material.clippingPlanes = [_this.localPlane_BRB_B];
            _this.model.getObjectByName("BRB_R").children[0].material.clippingPlanes = [_this.localPlane_BRB_R];
          },
          //初始化状态
          initmodel(){
            let _this = this
            _this.showallcomponents()
            _this.ShowHideComponents(["ABCG","DCLS1","DCLS2","DCLS3","DCLS4","DCLS5","ABC","BBAG","BBBG","ABBG","ABBG2","DK","XXK","BRB_B","BRB_R","BRR_B","BRR_R","BRG_B","BRG_R","BRG_G","ABAG2","ABCG2"],false)
          },
          /**
           * @description 所有组件透明度1
           */
          showallcomponents(){
            let _this = this
            _this.model.traverse(function (object) {
              object.visible = true
              if (object.isMesh) {
                object.material.depthWrite = true
                object.material.opacity = 1
              }
            })
          },
          //显示隐藏注意提示
          shownote(){
            this.is_hidenote = !this.is_hidenote
          },
          /**
           * @description 射线拾取模型
           */
          raycasterclick(){
            let _this = this
            _this.renderer.domElement.addEventListener('click', function (event) {
              // .offsetY、.offsetX以canvas画布左上角为坐标原点,单位px
              const px = event.offsetX;
              const py = event.offsetY;
              //屏幕坐标px、py转WebGL标准设备坐标x、y
              //width、height表示canvas画布宽高度
              const x = (px / event.srcElement.clientWidth) * 2 - 1;
              const y = -(py / event.srcElement.clientHeight) * 2 + 1;
              //创建一个射线投射器`Raycaster`
              const raycaster = new THREE.Raycaster();
              //.setFromCamera()计算射线投射器`Raycaster`的射线属性.ray
              // 形象点说就是在点击位置创建一条射线，射线穿过的模型代表选中
              raycaster.setFromCamera(new THREE.Vector2(x, y), _this.camera);
              //.intersectObjects([mesh1, mesh2, mesh3])对参数中的网格模型对象进行射线交叉计算
              // 未选中对象返回空数组[],选中一个对象，数组1个元素，选中两个对象，数组两个元素
              const intersects = raycaster.intersectObjects([_this.model]);
              // console.log("射线器返回对象", intersects);
              // intersects.length大于0说明，说明选中了模型
              if (intersects.length > 0) {
                console.log("射线器返回对象", intersects);
              }else{
                console.log('null');
              }
            })
          },
          /**
           * @description 显示透明组件
           * @param {array} e 透明名列表
           * @param {Boolean} e （false透明）or（true取消透明）
           */
          transparentComponents(objectArray,opcity,determine = false){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).material.transparent = false
                  _this.model.getObjectByName(objectArray[i]).material.opacity = 1
                } else if (_this.model.getObjectByName(objectArray[i]) instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[j].material.transparent = false
                    _this.model.getObjectByName(objectArray[i]).children[j].material.opacity = 1
                  }
                }
              }
            }else{ //透明
              for (let i = 0; i < objectArray.length; i++) {
                // console.log(_this.model.getObjectByName(objectArray[i]),objectArray[i]);
                if (_this.model.getObjectByName(objectArray[i]).children[0] instanceof THREE.Mesh) {
                  _this.model.getObjectByName(objectArray[i]).children[0].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                  _this.model.getObjectByName(objectArray[i]).children[0].material.transparent = true
                  _this.model.getObjectByName(objectArray[i]).children[0].material.opacity = opcity
                } else if (_this.model.getObjectByName(objectArray[i]).children[0] instanceof THREE.Group) {
                  for (let j = 0; j < _this.model.getObjectByName(objectArray[i]).children[0].children.length; j++) {
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.depthWrite = false // 不遮挡后面的模型  // depthWrite: false // 关闭深度测试
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.transparent = true
                    _this.model.getObjectByName(objectArray[i]).children[0].children[j].material.opacity = opcity
                  }
                }
              }
            }
          },
          /**
           * @description 显示隐藏组件
           * @param {array} e 隐藏名列表
           * @param {Boolean} e （0隐藏）or（1显示）
           */
          ShowHideComponents(objectArray,determine){
            let _this = this
            if(determine){ //显示
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = true
              }
            }else{ //隐藏
              for (let i = 0; i < objectArray.length; i++) {
                _this.model.getObjectByName(objectArray[i]).visible = false
              }
            }
          },
          handleChildEvent(){
            this.lang = sessionStorage.getItem('language')
            this.$refs.navchild.childchangelang();
            if (this.lang == 'cn') {
              if(this.selectobject.warn){
                this.attentionText = this.selectobject.warn;
              }else{
                this.attentionText = null
              }
            } else {
              if(this.selectobject.en_warn){
                this.attentionText = this.selectobject.en_warn;
              }else{
                this.attentionText = null
              }
            }
          },
          /**
           * @description 测试按钮
           */
          test(){
            let _this = this
            // console.log(_this.model.getObjectByName("ZX"),"ZX");
            // console.log(_this.model.getObjectByName("ABC"),"ABC");
            // _this.ShowHideComponents(["ZXNB"],false)
            // _this.transparentComponents(["ZX","ABC","CB1","CB2"],0.3)
            _this.showallcomponents()
            console.log(_this.model.getObjectByName("BRR_B"));
            // console.log(_this.model.getObjectByName("YC"),"YC");
            // console.log(_this.model.getObjectByName("yougan"),"yougan");
            // console.log(_this.model.getObjectByName("LAN"),"LAN");
            // console.log(_this.model.getObjectByName("LV"),"LV");
            // for (let i = 1; i < 7; i++) {
            //   console.log(_this.model.getObjectByName("HG"+i),"HG"+i);
            // }
            // for (let i = 1; i < 4; i++) {
            //   console.log(_this.model.getObjectByName("HX"+i),"HX"+i);
            // }
          },
        },
        mounted: function () {
          let _this = this;
          _this.initCanvas();
          _this.timer = setInterval(function() {
              if ( !_this.hadLoaded ) {
                  if ( _this.loadprogress < 80 ) {
                      _this.loadprogress += 0.8;
                  } else if ( _this.modelLoaded ) {
                      if ( _this.loadprogress <= 100 ) {
                          _this.loadprogress += 2;
                      } else {
                          _this.hadLoaded = true;
                          clearInterval(_this.timer);
                          _this.timer = null;
                      }
                  }
              }
          }, 20);
          // this.raycasterclick()
          window.addEventListener("resize", _this.onResize, false);
          if(sessionStorage.getItem('language')){
            this.lang = sessionStorage.getItem('language'); // 存入一个值
          }else{
            sessionStorage.setItem('language',this.lang); // 存入一个值
          }
        },
        beforeDestroy(){
          let _this = this
          _this.scene.remove(_this.model)
          _this.model.traverse(function (object) {
            if (object.type === 'Mesh') {
              object.geometry.dispose()
              object.material.dispose()
            }
          })
        },

    }
</script>

<style scoped>
  .v-enter{
    opacity: 0;
  }
  .v-enter-to{
    opacity: 1;
  }
  .v-enter-active{
    transition: all 1s;
  }
  .v-leave{
    opacity: 1;
  }
  .v-leave-to{
    opacity: 0;
  }
  .v-leave-active{
    transition: all 1s;
  }
  .test{
    position: absolute;
    z-index: 10000;
    top: 0px;
    background-color: red;
    width: 50px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
  }
  .sub-nav{
    position: absolute;
    top: 50%;
    right: 50px;
  }
  .sub-item{
    background-color: #34353a;
    border-radius: 5px;
    color: #fff;
    padding: 10px 15px;
    margin: 5px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .accessoryactive{
    background-color: #e71629 !important;
  }
  .img_annotate{
    position: absolute;
    top: 30%;
    right: 50px;
    background-color: #ffffff78;
    padding: 20px;
    border-radius: 10px;
  }
  .img_annotate img{
    /* border: 1px solid #000; */
  }
</style>



// WEBPACK FOOTER //
// src/components/zhxkfpq.vue